'use strict';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".lg-preview-fade-enter-active,.lg-preview-fade-leave-active{-webkit-transition:opacity .5s;transition:opacity .5s}.lg-preview-fade-enter,.lg-preview-fade-leave-active{opacity:0}.lg-preview-wrapper{position:fixed;top:0;left:0;width:100%;height:100%;text-align:center;box-sizing:border-box;background:rgba(0,0,0,.9);z-index:10000}.lg-preview-wrapper .lg-preview-loading{position:absolute;width:30px;height:35px;top:50%;left:50%;margin-top:-17.5px;margin-left:-15px}.lg-preview-wrapper .lg-preview-loading>div{display:inline-block;height:25px;width:25px;background:transparent;border-radius:100%;border:2px solid;border-color:#fff #fff transparent;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:lg-preview-loading-rotate .75s linear 0s infinite;animation:lg-preview-loading-rotate .75s linear 0s infinite}@-webkit-keyframes lg-preview-loading-rotate{0%{-webkit-transform:rotate(0deg) scale(1);transform:rotate(0deg) scale(1)}50%{-webkit-transform:rotate(180deg) scale(.6);transform:rotate(180deg) scale(.6)}to{-webkit-transform:rotate(1turn) scale(1);transform:rotate(1turn) scale(1)}}@keyframes lg-preview-loading-rotate{0%{-webkit-transform:rotate(0deg) scale(1);transform:rotate(0deg) scale(1)}50%{-webkit-transform:rotate(180deg) scale(.6);transform:rotate(180deg) scale(.6)}to{-webkit-transform:rotate(1turn) scale(1);transform:rotate(1turn) scale(1)}}.lg-preview-wrapper .lg-preview-img{max-width:100%;max-height:100%;display:block;position:absolute;left:0;top:0;bottom:0;right:0;margin:auto}.lg-preview-wrapper .lg-preview-nav-arrow{position:absolute;top:50%;margin-top:-15px;background:transparent;line-height:40px;width:20px;height:20px;border-top:2px solid #fff;border-left:2px solid #fff}.lg-preview-wrapper .lg-preview-nav-left,.lg-preview-wrapper .lg-preview-nav-right{position:absolute;height:100%;margin:0 5px;width:200px;top:0;color:#fff;-webkit-transition:opacity .2s;transition:opacity .2s}.lg-preview-wrapper .lg-preview-nav-left{left:0}.lg-preview-wrapper .lg-preview-nav-left .lg-preview-nav-arrow{left:0;margin-left:40px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.lg-preview-wrapper .lg-preview-nav-right{right:0}.lg-preview-wrapper .lg-preview-nav-right .lg-preview-nav-arrow{right:0;margin-right:40px;-webkit-transform:rotate(135deg);transform:rotate(135deg)}.lg-preview-wrapper .lg-preview-title{position:absolute;left:0;bottom:0;text-align:center;width:100%;color:#fff;background:rgba(0,0,0,.5);box-sizing:border-box;font-size:16px;height:40px;line-height:40px}@media (max-width:768px){.lg-preview-wrapper .lg-preview-nav-left,.lg-preview-wrapper .lg-preview-nav-right{width:100px}.lg-preview-wrapper .lg-preview-nav-left .lg-preview-nav-arrow{margin-left:20px}.lg-preview-wrapper .lg-preview-nav-right .lg-preview-nav-arrow{margin-right:20px}}";
styleInject(css);

//
var script = {
  name: 'Preview',
  computed: {
    preview: function preview() {
      return window.LOGIC_EVENT_BUS.LOGIC_PREVIEW;
    }
  },
  watch: {
    $route: function $route() {
      this.preview.show = false;
    }
  },
  methods: {
    leave: function leave(e) {
      if (this.preview.show && e.target.className.indexOf('lg-preview-nav-arrow') !== 0) {
        this.close();
      }
    },
    close: function close() {
      this.preview.show = false;
    },
    preAction: function preAction() {
      this.preview.loading = true;
      var index = this.preview.list.indexOf(this.preview.current);

      if (index === 0) {
        this.preview.loading = false;
        return;
      }

      index--;
      this.preview.current = this.preview.list[index];
      var img = new window.Image();
      img.src = this.preview.current.src;

      img.onload = function () {
        setTimeout(function () {
          window.LOGIC_EVENT_BUS.LOGIC_PREVIEW.loading = false;
        }, 500);
      };
    },
    nextAction: function nextAction() {
      this.preview.loading = true;
      var index = this.preview.list.indexOf(this.preview.current);

      if (index === this.preview.list.length - 1) {
        this.preview.loading = false;
        return;
      }

      index++;
      this.preview.current = this.preview.list[index];
      var img = new window.Image();
      img.src = this.preview.current.src;

      img.onload = function () {
        setTimeout(function () {
          window.LOGIC_EVENT_BUS.LOGIC_PREVIEW.loading = false;
        }, 500);
      };
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", { attrs: { name: "lg-preview-fade" } }, [
    _vm.preview.show
      ? _c(
          "div",
          {
            staticClass: "lg-preview-wrapper",
            on: {
              click: _vm.leave,
              touchmove: function($event) {
                $event.preventDefault();
              }
            }
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.preview.loading,
                    expression: "preview.loading"
                  }
                ],
                staticClass: "lg-preview-loading"
              },
              [_c("div")]
            ),
            _vm._v(" "),
            _vm.preview.current.src
              ? _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.preview.loading,
                      expression: "!preview.loading"
                    }
                  ],
                  staticClass: "lg-preview-img",
                  attrs: {
                    src: _vm.preview.current.src,
                    alt: _vm.preview.current.title
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.preview.isTitleEnable && _vm.preview.current.title
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.preview.loading,
                        expression: "!preview.loading"
                      }
                    ],
                    staticClass: "lg-preview-title"
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.preview.current.title) + "\n    "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.preview.isHorizontalNavEnable
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.preview.loading,
                        expression: "!preview.loading"
                      }
                    ],
                    staticClass: "lg-preview-nav-left"
                  },
                  [
                    _c("span", {
                      staticClass: "lg-preview-nav-arrow",
                      on: {
                        click: function($event) {
                          $event.stopPropagation();
                          return _vm.preAction($event)
                        }
                      }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.preview.isHorizontalNavEnable
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.preview.loading,
                        expression: "!preview.loading"
                      }
                    ],
                    staticClass: "lg-preview-nav-right"
                  },
                  [
                    _c("span", {
                      staticClass: "lg-preview-nav-arrow",
                      on: {
                        click: function($event) {
                          $event.stopPropagation();
                          return _vm.nextAction($event)
                        }
                      }
                    })
                  ]
                )
              : _vm._e()
          ]
        )
      : _vm._e()
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var lgPreview = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var index = {
  install: function install(Vue) {
    // 添加的内容写在这个函数里面
    var LOGIC_EVENT_BUS = new Vue({
      data: function data() {
        return {
          LOGIC_PREVIEW: {
            isTitleEnable: true,
            isHorizontalNavEnable: true,
            show: false,
            loading: true,
            current: {
              title: '',
              src: ''
            },
            list: []
          }
        };
      }
    });
    window.LOGIC_EVENT_BUS = LOGIC_EVENT_BUS;
    Vue.component('lg-preview', lgPreview);

    var updateIndex = function updateIndex(list) {
      list.forEach(function (item, index) {
        item.index = index + 1;
      });
    };

    var getImage = function getImage(src, previewItem) {
      var img = new window.Image();
      img.src = src;

      img.onload = function () {
        previewItem['naturalHeight'] = img.naturalHeight;
        previewItem['naturalWidth'] = img.naturalWidth;
        setTimeout(function () {
          LOGIC_EVENT_BUS.LOGIC_PREVIEW.loading = false;
        }, 500);
      };

      img.error = function (e) {
        console.error(e);
      };
    };

    Vue.directive('preview', {
      bind: function bind(el, binding) {
        var previewItem = {
          title: el.alt || '',
          el: el,
          index: 0,
          src: binding.value
        };
        LOGIC_EVENT_BUS.LOGIC_PREVIEW.list.push(previewItem);
        updateIndex(LOGIC_EVENT_BUS.LOGIC_PREVIEW.list);
        el.addEventListener('click', function (e) {
          e.stopPropagation();
          LOGIC_EVENT_BUS.LOGIC_PREVIEW.isTitleEnable = el.getAttribute('preview-title-enable') == 'false' ? false : true;
          LOGIC_EVENT_BUS.LOGIC_PREVIEW.isHorizontalNavEnable = el.getAttribute('preview-nav-enable') == 'false' ? false : true;
          LOGIC_EVENT_BUS.LOGIC_PREVIEW.show = true;
          LOGIC_EVENT_BUS.LOGIC_PREVIEW.loading = true;
          LOGIC_EVENT_BUS.LOGIC_PREVIEW.current = previewItem;
          getImage(previewItem.src, previewItem);
        });
      },
      update: function update(el, oldValue) {
        var previewItem = LOGIC_EVENT_BUS.LOGIC_PREVIEW.list.find(function (item) {
          return item.el === el;
        });
        if (!previewItem) return;
        previewItem.src = oldValue.value;
        previewItem.title = el.alt;
      },
      unbind: function unbind(el) {
        if (el) {
          LOGIC_EVENT_BUS.LOGIC_PREVIEW.list.forEach(function (item, index) {
            if (el === item.el) {
              LOGIC_EVENT_BUS.LOGIC_PREVIEW.list.splice(index, 1);
            }
          });
        }

        updateIndex(LOGIC_EVENT_BUS.LOGIC_PREVIEW.list);
      }
    });
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vue-picture-preview/dist/vue-picture-preview.js
// module id = QQuR
// module chunks = 1